import { useFormik } from "formik";
import React from "react";
// import { useDispatch, useSelector } from "react-redux";
import { useDispatch } from "react-redux";
// import { AppDispatch, RootState } from "../../../../Store";
import { AppDispatch } from "../../../../Store";
import { fetchChangepassworddata } from "./Securityslice";

export default function Securitydetails() {

    // const datas = useSelector((state: RootState) => state.Changepassworddata.Changepassworddata)

    const Dispatch: AppDispatch = useDispatch()

    const login = useFormik({
        initialValues: {
            currentpassword: '',
            newpassword: '',
            confirmnewpassword: ''
        },
        onSubmit: (data: any) => {
            return new Promise((resolve) => {
                setTimeout(() => {
                    resolve(undefined);
                    if (data.newpassword === data.confirmnewpassword) {
                        console.log(data);
                        Dispatch(fetchChangepassworddata(data))
                        alert("password change successfully")
                    }
                }, 3000)
            })
        },
    });

    return (
        <>

            {/* Securitydetails start */}

            <div className="security_details">
                <div className="d-flex justify-content-between createaccountpage_content_header_container">
                    <div className="d-flex">
                        <div>
                            <div className="createaccountpage_content_header">
                                Password and Privacy
                            </div>
                            <div className="createaccountpage_content_text">
                                Change and secure your account
                            </div>
                        </div>
                        <div>
                            <button type="button" className="createaccountpage_edit_button">
                                Edit
                            </button>
                        </div>
                    </div>
                </div>

                <div className="createaccountpage_margin_bottom">

                    <button className="createaccountpage_content_button" data-bs-toggle="collapse" data-bs-target="#yourpassword" aria-expanded="true" aria-controls="yourpassword">
                        Your Password
                    </button>
                    <div id="yourpassword" className="collapse show" aria-labelledby="headingOne" data-bs-parent="#accordion">

                        <form onSubmit={login.handleSubmit}>
                            <table className="createaccountpage_content_table">
                                <tbody>
                                    <tr>
                                        <td>Current Password</td>
                                        <td>
                                            <input className="createaccountpage_content_security_password" type="password" name="currentpassword" id="currentpassword" defaultValue={123456} onChange={login.handleChange} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>New Password</td>
                                        <td>
                                            <input className="createaccountpage_content_security_password" type="password" name="newpassword" id="newpassword" defaultValue={123456} onChange={login.handleChange} />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Confirm New Password</td>
                                        <td>
                                            <input className="createaccountpage_content_security_password" type="password" name="confirmnewpassword" id="confirmnewpassword" defaultValue={123456} onChange={login.handleChange} />
                                        </td>
                                    </tr>
                                    <tr className="d-none">
                                        <td>
                                            <button type="submit">changepasword</button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </form>
                    </div>
                </div>
            </div>

            {/* Securitydetails over */}
        </>
    )

}